import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PlatformRoute = ({ element: Element }) => {
  const { isAuthenticated, user, authLoading } = useAuth();

  if (authLoading) return null;

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (user?.roleName !== 'SuperAdmin') {
    return <Navigate to="/index/dashboard" />;
  }

  return <Element />;
};

export default PlatformRoute;
